import React, { useCallback, useEffect, useState } from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { AiFillDelete } from "react-icons/ai";
import { FaPlus } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { fetchAsyncGetItem } from "redux/purchaseItemSlice";
import ColumnTable from '../embrillTable/ColumnTable';
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import { fetchAsyncDeleteItem } from "redux/purchaseItemSlice";
import AddItemForm from "components/allForm/PurchaseItem/addItemForm";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import prJson from "components/jsonData/purchase.json";
import { prItemDataColumns } from "../embrillTable/variables/colData";
import { taxOptions } from "components/allForm/PurchaseItem/selectedOptions";
import useSearch from "hooks/useSearch";
const PurchaseItem = () => {
  const dispatch = useDispatch();
  const [itemListData, setItemListData] = useState([]);
  const currUser = useSelector((state) => state.auth.currUser);
  const [role,setRole] = useState('')  
  const searchValue = useSelector((state) => state.searchValue); 
  const {searchText} = searchValue;
  const { performSearch } = useSearch();
  useEffect(()=>{
    if(currUser && currUser?.auth){

      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Purchase Items');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
   
  },[currUser])

  const [openItemModal, setOpenItemModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [itemEditData, setItemEditData] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenItemModal = () => {
    setOpenItemModal(true);
  };

  const handleCloseItemModal = () => {
    setOpenItemModal(false);
    setOpenEditModal(false);
    setItemEditData(null);
    handlerRefreshData();
  };

  const handlerRefreshData = useCallback(
    () => {
      performSearch(searchText);
    },
    [searchText,performSearch]
  );

  const itemList = useSelector((state) => state.purchaseItemData);

  const deleteItem = (data) => {
    dispatch(fetchAsyncDeleteItem(data._id)).then(() => {
      handlerRefreshData();
    });
  };
  
  useEffect(() => {
    if (itemList && itemList.length > 0) {
        const tableData = itemList.map((data, index) => {
          const iStatetaxRate = taxOptions.find((opt)=>opt.id === data.istr)
            return {
              _id:data._id,
              no: index + 1,
              
              name:(
                <span 
                  style={{ cursor: "pointer",color:'blue'}}
                >
                  {data?.name}
                </span>
              ),
              type: data?.typ,
              taxRate:iStatetaxRate ? iStatetaxRate?.label : '-',

              itemcode:data?.typ === 'goods' ? data?.hCd : data?.sCd,
              
              sortSellPrice:Number(data?.prc) || 0,
              sellingPrice:<Box display="flex" >
              <span
                  style={{fontWeight:'600'}}
                  className={ data?.prc ? 'green' :''}
    
                >
                  {formatAmountInINR(data?.prc ? parseFloat(data?.prc) : 0)}
                </span>
              
               </Box>,
              action: (
                <div className="d-flex">
             <MdModeEdit
                className="me-2"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleEditClick(e,data._id)
                }}
              />
              
                  {role === "Admin" ? (
                    <AiFillDelete
                      style={{ cursor: "pointer",marginLeft:'10px' }}
                      size={16}
    
                      onClick={(e) => {
                        e.preventDefault();
                        ConfirmationDialog({
                          title: prJson.confirm.deleteItem,
                          text:prJson.text.undone,
                          icon: 'warning',
                          confirmButtonText: 'Delete',
                          cancelButtonText: 'Cancel',
                          onConfirm: () => {
                            deleteItem(data);
                          },
                        });
                      }}
                    />
                  ):'No Access'}
                </div>
              ),
            };
          });
      setItemListData(tableData);
    } else {
      setItemListData([]);
    }
  }, [itemList]);


  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const data = itemList.filter((item)=> item?._id === _id)
    setOpenEditModal(true);
    setItemEditData(data[0]);
    handleOpenItemModal();
  }

  const handleEditClick = (e,_id)=>{
    e.stopPropagation();
    const data = itemList.filter((item)=> item?._id === _id)
    setOpenEditModal(true);
    setItemEditData(data[0]);
    handleOpenItemModal();
  }

  

useEffect(() => {
  setLoading(true); 
  dispatch(fetchAsyncGetItem())
    .then(() => {
      setLoading(false); 
    })
    .catch((error) => {
      setLoading(false); 
    });
  }, []);
  const textColor = useColorModeValue("secondaryGray.900", "white");


   // If loading, return a spinner
   if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
      <Box display="flex" className="mx-0" justifyContent="space-between">
      <Box display="flex">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
          mx={2}
        >
          Purchase Items
        </Text>
       
        </Box>
        <Box display="flex" mt={2} className="add-new-btn">
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleOpenItemModal}
          >
            <FaPlus size={12} className="new-plus-icon"/> New
          </Box>
            
        
         
        </Box>
     
      
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <ColumnTable
          columnsData={prItemDataColumns}
          tableData={itemListData}
          type={"Items"}
          role={role}
          expenseType = 'items'
          openInfoModal = {handleRowClick}

        />
      </Box>
      {openItemModal && (
        <AddItemForm
        isOpen={openItemModal}
          closeModal={() => {
            handleCloseItemModal();
          }}
          isEdit={openEditModal}
          editData={itemEditData}
          listItemBtn={false}
        />
      )}
     
    </>
  );
};

export default PurchaseItem;
